module.exports = __webpack_public_path__ + "img/224.15a62196.jpg";